import styled from 'styled-components';

import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

export const SelectWrapper = styled.div`
  position: relative;
  margin-bottom: ${OFFSET.M};

  ${media.tablet} {
    margin: ${OFFSET.M} 0;
  }
`;
